package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_01_14_Day_1
import com.veldekar.components.logs.Log_2023_01_14_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-01-14")
@Composable
public fun Log_2023_01_14(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Introduction at the Leering Stag",
        ogTitle = "Introduction at the Leering Stag",
        date = LocalDate(2_023, 1, 14),
        ogDescription = "Heroes gather at the Leering Stag inn, introducing themselves and taking a contract to find missing brothers.",
        ogImage = "ai/2023-01-14.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-8", dateString = "Newgrowth 8")
        Log_2023_01_14_Day_1()
        SessionDayHeader(dayId = "newgrowth-9", dateString = "Newgrowth 9")
        Log_2023_01_14_Day_2()
    }
}
